import palette from "../palette";

const MuiListItemIcon = {
  root: {
    color: palette.icon,
    minWidth: 32,
  },
};

export default MuiListItemIcon;
